module.exports = __webpack_public_path__ + "img/cloud2.663bc400.svg";